import { Action } from "redux";

export type AuthSetTokenRequest = "AUTH_SET_TOKEN";
export const AUTH_SET_TOKEN_REQUEST: AuthSetTokenRequest = "AUTH_SET_TOKEN";

export interface AuthSetTokenProps {
    accessToken: string;
    expiresInSeconds: number;
    moveTo?: string;
    refreshToken?: string;
}

export interface AuthSetTokenAction extends Action {
    payload: AuthSetTokenProps;
    type: AuthSetTokenRequest;
}

export function setToken(tokenProps: AuthSetTokenProps): AuthSetTokenAction {
    return {
        payload: tokenProps,
        type: AUTH_SET_TOKEN_REQUEST
    };
}
